module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh_cn":{"publish":"发布"},"zh_hk":{"publish":"發布"},"en":{"publish":"publish"},"ja":{"publish":"リリース"}}')
  delete Component.options._Ctor
}
